var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _class2;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { attr } from '@ember-data/model';
import { fragment } from 'ember-data-model-fragments/attributes';
import CatalogFragment from '@square/dashboard-items-data/models/connect/catalog-fragment';
import { SubscriptionCadence as SubscriptionCadenceProto } from '@square/dashboard-protos/models/squareup/connect/v2/catalog/resources/enums';
export let SubscriptionCadence = /*#__PURE__*/function (SubscriptionCadence) {
  SubscriptionCadence["DAILY"] = "DAILY";
  SubscriptionCadence["WEEKLY"] = "WEEKLY";
  SubscriptionCadence["EVERY_TWO_WEEKS"] = "EVERY_TWO_WEEKS";
  SubscriptionCadence["THIRTY_DAYS"] = "THIRTY_DAYS";
  SubscriptionCadence["SIXTY_DAYS"] = "SIXTY_DAYS";
  SubscriptionCadence["NINETY_DAYS"] = "NINETY_DAYS";
  SubscriptionCadence["MONTHLY"] = "MONTHLY";
  SubscriptionCadence["EVERY_TWO_MONTHS"] = "EVERY_TWO_MONTHS";
  SubscriptionCadence["QUARTERLY"] = "QUARTERLY";
  SubscriptionCadence["EVERY_FOUR_MONTHS"] = "EVERY_FOUR_MONTHS";
  SubscriptionCadence["EVERY_SIX_MONTHS"] = "EVERY_SIX_MONTHS";
  SubscriptionCadence["ANNUAL"] = "ANNUAL";
  SubscriptionCadence["EVERY_TWO_YEARS"] = "EVERY_TWO_YEARS";
  return SubscriptionCadence;
}({});
let Phase = (_dec = attr('string'), _dec2 = attr('string', {
  protoEnum: SubscriptionCadenceProto
}), _dec3 = attr('number'), _dec4 = fragment('price-money'), _dec5 = attr('number'), _dec6 = fragment('connect/subscription-plan/pricing'), _class = (_class2 = class Phase extends CatalogFragment {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "uid", _descriptor, this);
    _initializerDefineProperty(this, "cadence", _descriptor2, this);
    _initializerDefineProperty(this, "periods", _descriptor3, this);
    _initializerDefineProperty(this, "recurringPriceMoney", _descriptor4, this);
    _initializerDefineProperty(this, "ordinal", _descriptor5, this);
    _initializerDefineProperty(this, "pricing", _descriptor6, this);
  }
}, _defineProperty(_class2, "_modelNameForMigration", 'connect/subscription-plan/phase'), _class2), _descriptor = _applyDecoratedDescriptor(_class.prototype, "uid", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "cadence", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "periods", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "recurringPriceMoney", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "ordinal", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "pricing", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export { Phase as default };